// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { FulfillmentLineItemsTable } from '@/fulfillment/components/fulfillment-line-items-table';
import { useFulfillment } from '@/fulfillment/hooks/use-fulfillment';
import { useShipments } from '@/shipment/hooks/use-shipments';
import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/fulfillments/$fulfillmentKey/')({
  component: FulfillmentLineItemsTab,
});

function FulfillmentLineItemsTab() {
  const { fulfillmentKey } = Route.useParams();
  const { fulfillment } = useFulfillment(fulfillmentKey);
  const { shipments } = useShipments({
    filter: { foNumbers: [fulfillment.fulfillmentOrderNumber] },
  });

  return (
    <HardfinTabCardWrapper title="Line items">
      <Box paddingY={1} paddingX={0}>
        <FulfillmentLineItemsTable
          items={fulfillment.items}
          shipments={shipments}
        />
      </Box>
    </HardfinTabCardWrapper>
  );
}
